<template>
  <div
    class="modal fade complete-change-form-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myLargeModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="container py-4 px-4">
          <b><h4>Complete Change Form</h4></b>
          <b><label for="">Completed By</label></b>
          <div class="form-group">
            <input
              type="text"
              name=""
              id=""
              class="form-control"
              v-model="change.completed_by"
            />
          </div>

          <b><label for="">Action Taken</label></b>
          <div class="form-group">
            <textarea
              name=""
              id=""
              cols="30"
              rows="1"
              class="form-control"
              placeholder=""
              v-model="change.action_taken"
            ></textarea>
          </div>

          <div class="form-group">
            <button class="btn btn-success" @click="completeRequest">
              Complete
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "CompleteModal",
  components: {},
  data() {
    return {
      pending_changes: [],

      completed_changes: [],
      change: {
        completed_by: "",
        action_taken: ""
      },

      change_form_id: this.$store.state.change_form_id
    };
  },

  methods: {
    completeRequest() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        swal({
          icon: "warning",
          text: "Are you sure?",
          buttons: ["Cancel", "Yes"]
        }).then(confirm => {
          if (confirm) {
            axios
              .post(
                `/change_form/${this.$store.state.change_form_id}/completed`,
                {
                  completed_by: this.change.completed_by,
                  action_taken: this.change.action_taken
                },
                {
                  headers: {
                    Authorization: "Bearer " + token
                  }
                }
              )
              .then(res => {
                if (res.data.authorised === false) {
                  swal({
                    icon: "error",
                    text: "Not authorised"
                  });
                } else {
                  if (res.data.success === true) {
                    swal({
                      icon: "success",
                      text: res.data.message
                    }).then(ok => {
                      this.$root.$emit("ChangeFormsLoadAllChangeForms");
                      $(".complete-change-form-modal").modal("hide");
                    });
                  } else {
                    swal({
                      icon: "error",
                      text: res.data.message
                    });
                  }
                }
              });
          } else {
            swal({
              icon: "info",
              text: "Cancelled"
            });
          }
        });
      }
    }
  },

  mounted() {}
};
</script>
